<template>
  <div>
    <div id="overlay" @click="$emit('close-form')"></div>
    <div id="form">
      <div class="row container-form details-area">
        <b-form novalidate class="col-xs-12">
          <div class="header-form">
            <div v-if="formType == 'edit'" class="my-2 d-flex align-items-center justify-content-center">
              <bell-icon title="" class="mb-1" />
              <span>
                Editando alerta do DIR-{{ form.DIR_ID }}
              </span>
            </div>
            <div v-else class=""><bell-icon title="" />Adicionar alerta</div>
          </div>
          <div class="pl-3 pr-3 mt-4">
            <b-form-text class="header-form border-0 text-left">
              <strong>Bateria:</strong>
            </b-form-text>

            <div class="mb-3">
              <b-form-text>Medição <strong>mínima</strong> permitida ( V ):</b-form-text>
              <b-form-input
                v-model="form.BAT_LOW_RANGE"
                placeholder="Exemplo: 10"
                :formatter="notEmpty"
                maxlength="24"
                size="sm"
                id="input_bat_low_range"
                aria-describedby="bat_low_rangeInput bat_low_rangeInputLiveFeedback"
                :state="bat_low_range_state"
              />
              <b-form-invalid-feedback
                v-if="!bat_low_range_state"
                id="bat_low_rangeInputLiveFeedback"
              >
                Obrigatório.
              </b-form-invalid-feedback>
            </div>
            
            <div class="mb-3">
              <b-form-text id="title-tolerance_low_bat">
                Tempo tolerado <strong>abaixo</strong> dos parâmetros ( min ):
              </b-form-text>

              <b-form-input
                v-model="form.TOLERANCE_LOW_BAT"
                placeholder="Exemplo: 30"
                :formatter="notEmpty"
                maxlength="24"
                size="sm"
                id="input-tolerance_low_bat"
                aria-describedby="tolerance_low_batInput tolerance_low_batInputLiveFeedback"
                :state="tolerance_low_bat_state"
              />
              <b-form-invalid-feedback
                v-if="!tolerance_low_bat_state"
                id="tolerance_low_batInputLiveFeedback"
              >
                Obrigatório. ( Tempo mínimo é de 1 minuto )
              </b-form-invalid-feedback>
            </div>

            <div class="mb-3">
              <b-form-text>Tempo de re-envio do alerta <strong>abaixo</strong> ( min ):</b-form-text>
              <b-form-input
                v-model="form.TIME_TO_RESEND_LOW_BAT"
                placeholder="Exemplo: 1440"
                :formatter="notEmpty"
                maxlength="24"
                size="sm"
                id="input_time_to_resend_low_bat"
                aria-describedby="time_to_resend_low_batInput time_to_resend_low_batInputLiveFeedback"
                :state="time_to_resend_low_bat_state"
              />
              <b-form-invalid-feedback
                v-if="!time_to_resend_low_bat_state"
                id="time_to_resend_low_batInputLiveFeedback"
              >
                Obrigatório. ( Tempo mínimo é de 30 minutos )
              </b-form-invalid-feedback>
            </div>
            
            <br>

            <div class="mb-3">
              <b-form-text>Medição <strong>máxima</strong> permitida ( V ):</b-form-text>
              <b-form-input
                v-model="form.BAT_HIGH_RANGE"
                placeholder="Exemplo: 10"
                :formatter="notEmpty"
                maxlength="24"
                size="sm"
                id="input_bat_high_range"
                aria-describedby="bat_high_rangeInput bat_high_rangeInputLiveFeedback"
                :state="bat_high_range_state"
              />
              <b-form-invalid-feedback
                v-if="!bat_high_range_state"
                id="bat_low_rangeInputLiveFeedback"
              >
                Obrigatório.
              </b-form-invalid-feedback>
            </div>

            <div class="mb-3">    
              <b-form-text id="title-tolerance_low_bat">
                Tempo tolerado <strong>acima</strong> dos parâmetros ( min ):
              </b-form-text>
                
              <b-form-input
                v-model="form.TOLERANCE_HIGH_BAT"
                placeholder="Exemplo: 30"
                :formatter="notEmpty"
                maxlength="24"
                size="sm"
                id="input-tolerance_low_signal"
                aria-describedby="tolerance_low_signalInput tolerance_low_signalInputLiveFeedback"
                :state="tolerance_high_bat_state"
              />
              <b-form-invalid-feedback
                v-if="!tolerance_high_bat_state"
                id="tolerance_low_signalInputLiveFeedback"
              >
                Obrigatório. ( Tempo mínimo é de 1 minuto )
              </b-form-invalid-feedback>
            </div>

            <div class="mb-3">
              <b-form-text>Tempo de re-envio do alerta <strong>acima</strong> ( min ):</b-form-text>
              <b-form-input
                v-model="form.TIME_TO_RESEND_HIGH_BAT"
                placeholder="Exemplo: 1440"
                :formatter="notEmpty"
                maxlength="24"
                size="sm"
                id="input_time_to_resend_high_bat"
                aria-describedby="input_time_to_resend_high_bat input_time_to_resend_high_batLiveFeedback"
                :state="time_to_resend_high_bat_state"
              />
              <b-form-invalid-feedback
                v-if="!time_to_resend_high_bat_state"
                id="input_time_to_resend_high_batInputLiveFeedback"
              >
                Obrigatório. ( Tempo mínimo é de 30 minutos )
              </b-form-invalid-feedback>
            </div>

            <b-form-text class="header-form border-0 text-left mt-4">
              <strong>Sinal:</strong>
            </b-form-text>

            <div class="mb-3">
              <b-form-text>Medição mínima permitida <strong>abaixo</strong> ( % ):</b-form-text>
              <b-form-input
                v-model="form.SIGNAL_LOW_RANGE"
                placeholder="Exemplo: 10"
                :formatter="notEmpty"
                maxlength="24"
                size="sm"
                id="input_signal_low_range"
                aria-describedby="signal_low_rangeInput signal_low_rangeInputLiveFeedback"
                :state="signal_low_range_state"
              />
              <b-form-invalid-feedback
                v-if="!signal_low_range_state"
                id="signal_low_rangeInputLiveFeedback"
              >
                Obrigatório.
              </b-form-invalid-feedback>
            </div>

            <div class="mb-3">    
              <b-form-text id="title-tolerance_low_bat">
                Tempo tolerado <strong>abaixo</strong> dos parâmetros ( min ):
              </b-form-text>
                
              <b-form-input
                v-model="form.TOLERANCE_LOW_SIGNAL"
                placeholder="Exemplo: 30"
                :formatter="notEmpty"
                maxlength="24"
                size="sm"
                id="input-tolerance_low_signal"
                aria-describedby="tolerance_low_signalInput tolerance_low_signalInputLiveFeedback"
                :state="tolerance_low_signal_state"
              />
              <b-form-invalid-feedback
                v-if="!tolerance_low_signal_state"
                id="tolerance_low_signalInputLiveFeedback"
              >
                Obrigatório. ( Tempo mínimo é de 1 minuto )
              </b-form-invalid-feedback>
            </div>

            <div class="mb-3">
              <b-form-text>Tempo de re-envio do alerta <strong>abaixo</strong> ( min ):</b-form-text>
              <b-form-input
                v-model="form.TIME_TO_RESEND_LOW_SIGNAL"
                placeholder="Exemplo: 1440"
                :formatter="notEmpty"
                maxlength="24"
                size="sm"
                id="input_time_to_resend_low_signal"
                aria-describedby="time_to_resend_low_signalInput time_to_resend_low_signalInputLiveFeedback"
                :state="time_to_resend_low_signal_state"
              />
              <b-form-invalid-feedback
                v-if="!time_to_resend_low_signal_state"
                id="time_to_resend_low_signalInputLiveFeedback"
              >
                Obrigatório. ( Tempo mínimo é de 30 minutos )
              </b-form-invalid-feedback>
            </div>
          </div>
        </b-form>
      </div>

      <b-modal
        ref="formError"
        no-close-on-backdrop
        centered
        hide-footer
        body-bg-variant="light"
        title="Atenção!"
      >
        <div class="modal-form row pb-3">
          <div class="col-xs-12 center-xs">
            <alert-icon title="" style="font-size: 3em; color: #ffc107" />
          </div>
          <div class="col-xs-12 error-title">
            Por favor,confira o formulário
          </div>
          <div class="col-xs-12 error-description">
            <ul>
              <li v-for="err in errors" :key="err">{{ err }}</li>
            </ul>
          </div>
        </div>
        <b-btn
          v-if="$refs.formError"
          block
          variant="secondary"
          size="sm"
          @click="formCorrect"
          >Irei corrigir</b-btn
        >
      </b-modal>

      <footer id="footer" class="pb-2 d-flex">
        <b-btn
          size="sm"
          variant="outline-secondary"
          @click="closeForm"
          class="mr-1 ml-2 w-100"
        >
          Fechar
        </b-btn>

        <b-btn
          block
          variant="3v3"
          @click="checkForm"
          size="sm"
          class="ml-1 mr-2 w-100"
        >
          Salvar
        </b-btn>
      </footer>
    </div>
  </div>
</template>

<script>
import { alerts } from "@/api";
import { user } from "@/pages/components/globalstore";
import {
  notEmpty,
  notRepeatedName,
} from "@/pages/components/regist/form-functions";

export default {
  name: "DirAlertForm",
  props: {
    formType: String,
    itemToEdit: [Number, Object],
    items: Array,
  },

  data() {
    return {
      errors: [],
      form: {
        ID_ALERT_DIR:null,
        DIR_ID: null,
        TOLERANCE_LOW_BAT: null,
        TOLERANCE_LOW_SIGNAL: null,
        TIME_TO_RESEND_LOW_BAT: null,
        TIME_TO_RESEND_LOW_BAT: null,
        TIME_TO_RESEND_LOW_SIGNAL: null,
        BAT_LOW_RANGE: null,
        SIGNAL_LOW_RANGE:null
      },
      updateParams: [],
      objEmail:[],
      emailAdd: "",
      arrayEmailsAdd:[],
      emailFormCopy: [],
      sensorSelectedRanges:[],
      rangesUpdated:[],
      counter:0,
      MIN:null,
      MAX:null
    };
  },
  computed: {
    oldName() {
      return this.itemToEdit && this.itemToEdit.NAME;
    },
    dir_id_state() {
      return !!this.form.DIR_ID;
    },
    tolerance_low_bat_state() {
      return !!this.form.TOLERANCE_LOW_BAT && this.form.TOLERANCE_LOW_BAT >= 1;
    },
    tolerance_low_signal_state() {
      return !!this.form.TOLERANCE_LOW_SIGNAL && this.form.TOLERANCE_LOW_SIGNAL >= 1;
    },
    tolerance_high_bat_state() {
      return !!this.form.TOLERANCE_HIGH_BAT && this.form.TOLERANCE_HIGH_BAT >= 1;
    },
    time_to_resend_low_bat_state() {
      return !!this.form.TIME_TO_RESEND_LOW_BAT && this.form.TIME_TO_RESEND_LOW_BAT >= 30;
    },
    time_to_resend_high_bat_state() {
      return !!this.form.TIME_TO_RESEND_HIGH_BAT && this.form.TIME_TO_RESEND_HIGH_BAT >= 30;
    },
    time_to_resend_low_signal_state() {
      return !!this.form.TIME_TO_RESEND_LOW_SIGNAL && this.form.TIME_TO_RESEND_LOW_SIGNAL >= 30;
    },
    bat_low_range_state(){
      return !!this.form.BAT_LOW_RANGE && this.form.BAT_LOW_RANGE >= 0;
    },
    bat_high_range_state(){
      return !!this.form.BAT_HIGH_RANGE && this.form.BAT_HIGH_RANGE >= 0;
    },
    signal_low_range_state(){
      return !!this.form.SIGNAL_LOW_RANGE && this.form.SIGNAL_LOW_RANGE >= 0;
    },
    notRepeatedName() {
      return notRepeatedName(this.form.NAME, this.formType, this.oldName);
    },
  },
  async created() {
    if (this.formType == "add") this.resetForm();
    else {
      this.form = JSON.parse(JSON.stringify(this.itemToEdit));
    }
  },
  methods: {
    async updateDirs(data){
      try {
        const copyData = {...data};

        delete copyData.ACTIVE_ALERTS

        await alerts.updateAlertDirs(
          user.ID,
              {
                data: copyData
              }
          );
          

          const dir = this.items.find(dir => dir.ID_ALERT_DIR == data[0].id_alert_dir);
          alert(`Sucesso ao atualizar alerta dor DIR ${dir.DIR_ID}`, "s")
  
          data.length = 0;

      } catch(e) {
        console.log('erro ao atualizar alerta de dir', e)
        const dir = this.items.find(dir => dir.ID_ALERT_DIR == data[0].id_alert_dir);
        
        if(dir) {
          alert(`Falha ao atualizar alerta dor DIR ${dir.DIR_ID}`, "e");

        } else {
          alert(`Falha ao editar alerta`, "e");

        }

      }
    },
    closeForm() {
      this.resetForm();
      this.$emit("close-form");
    },
    notEmpty(value) {
      return notEmpty(value);
    },
    resetForm() {
      this.firstFKModelChange = false;
      this.range = [];
      this.form = {
        ID_ALERT_DIR:null,
        DIR_ID: null,
        TOLERANCE_LOW_BAT: null,
        TOLERANCE_LOW_SIGNAL: null,
        TIME_TO_RESEND_HIGH_BAT: null,
        TIME_TO_RESEND_LOW_SIGNAL: null,
        BAT_LOW_RANGE: null,
        BAT_HIGH_RANGE: null,
        SIGNAL_LOW_RANGE:null
      };
      this.minMaxState = true;
    },
    formCorrect() {
      this.$refs.formError.hide();
      this.errors.length = 0;
    },
    async checkForm() {
      const states = [
        this.dir_id_state,
        this.tolerance_low_bat_state,
        this.tolerance_low_signal_state,
        this.ime_to_resend_low_bat_state,
        this.ime_to_resend_low_signal_state,
        this.bat_low_range_state,
        this.signal_low_range_state
      ];

      const errors = [
        "Nome inválido.",
        "Tempo de tolerância da bateria inválido.",
        "Tempo de tolerância do sinal inválido.",
        "Tempo de re-envio da bateria inválido.",
        "Tempo de re-envio do sinal inválido.",
        "Medição mínima da bateria inválida",
        "Medição mínima do sinal inválida",
      ];

      states.map((state, index) => {
        if (state === false) {
          this.errors.push(errors[index]);
        }
      });

      if (this.errors.length) this.$refs.formError.show();
      else {
        if (this.formType === "edit") {
          const keysForm = Object.keys(this.form);

          keysForm.forEach(keyForm => {
            if(this.form[keyForm] != this.itemToEdit[keyForm]) {
              this.updateParams.push({
                column: keyForm,
                value: this.form[keyForm],
                id_alert_dir: this.itemToEdit.ID_ALERT_DIR,
              });
            }
          });

          if (this.updateParams.length > 0) {
            await this.updateDirs(this.updateParams);
          }
          
          this.$emit('get-data-again');
          this.$emit('close-form');

          return;
        }
      }
    },
  },
};
</script>

<style scoped>
.error {
  color: #dc3545;
}
.sensors-measures > div {
  font-size: 0.8em;
}
#form {
  padding-left: 0;
  padding-right: 0;
}
@media screen and (max-width: 768px) {
  .container-form {
    padding-bottom: 3em;
    padding-left: 0.5em;
    padding-right: 0em;
    margin-right: 0;
  }
}
</style>
